import ActionTypes from '../action-types';

export interface NavigationAction {
  type: string;
  data: object;
}

const navigation = (state = {}, action: NavigationAction,) => {
  switch (action.type) {
    case ActionTypes.CLICK_EXPERT_REVIEWS_ACCORDION:
    case ActionTypes.CLICK_EXPERT_RATINGS_ACCORDION:
    case ActionTypes.CLICK_CONSUMER_REVIEWS_ACCORDION:
    case ActionTypes.CLICK_CONSUMER_RATINGS_ACCORDION:
    case ActionTypes.CLICK_AWARDS_ACCORDION:
    case ActionTypes.OPEN_GLOBAL_OVERLAY:
    case ActionTypes.CLOSE_GLOBAL_OVERLAY:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export default navigation;
